import React from "react";
import { motion } from "framer-motion";
import { Sparkles, ShieldCheck, Clock, Star, MapPin, Leaf } from "lucide-react";

const TRUST_ITEMS = [
  { icon: ShieldCheck, title: "Fully insured",         sub: "Liability + garage keepers" },
  { icon: Leaf,        title: "Paint-safe products",   sub: "pH-neutral, two-bucket" },
  { icon: Clock,       title: "2–3 hour service",      sub: "Done before you leave" },
  { icon: Star,        title: "5-star rated",          sub: "Satisfaction guarantee" },
  { icon: MapPin,      title: "Niskayuna, NY",         sub: "Mobile — we come to you" },
  { icon: Sparkles,    title: "Showroom finish",       sub: "Hand-dried, no swirls" },
];

export default function TrustSection() {
  return (
    <section
      className="section-sm position-relative"
      data-testid="booking-trust-section"
    >
      <div className="container" style={{ maxWidth: 1100 }}>
        <div className="text-center mb-5">
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="overline mb-3"
            style={{ color: "rgba(170,170,170,0.85)" }}
          >
            Why Nisky
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 1.0, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="font-semibold tracking-[-0.04em]"
            style={{ fontSize: "clamp(1.6rem, 4vw, 2.4rem)", color: "#f5f5f7" }}
          >
            Quality you can{" "}
            <em
              className="italic"
              style={{
                fontFamily: "'Instrument Serif', 'Fraunces', Georgia, serif",
                background: "var(--gold-gradient)",
                backgroundSize: "200% auto",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                animation: "gold-shimmer 6s linear infinite",
              }}
            >
              see
            </em>
            .
          </motion.h2>
        </div>

        <div className="row g-3 g-md-4">
          {TRUST_ITEMS.map((it, i) => (
            <div className="col-6 col-md-4" key={it.title}>
              <motion.div
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.7, delay: 0.05 * i, ease: [0.16, 1, 0.3, 1] }}
                className="h-100"
                style={{
                  background: "rgba(255,255,255,0.025)",
                  border: "none",
                  borderRadius: "16px",
                  padding: "20px 18px",
                  boxShadow: "inset 0 1px 0 rgba(255,255,255,0.03), 0 6px 20px rgba(0,0,0,0.25)",
                  transition: "all 0.4s cubic-bezier(0.25,0.46,0.45,0.94)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "inset 0 1px 0 rgba(138,138,138,0.10), 0 12px 32px rgba(0,0,0,0.35)";
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.background = "rgba(138,138,138,0.05)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "inset 0 1px 0 rgba(255,255,255,0.03), 0 6px 20px rgba(0,0,0,0.25)";
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.background = "rgba(255,255,255,0.025)";
                }}
              >
                <div className="d-flex align-items-center gap-3 mb-2">
                  <span
                    className="d-inline-flex align-items-center justify-content-center flex-shrink-0"
                    style={{
                      width: 36,
                      height: 36,
                      borderRadius: 10,
                      background: "rgba(138,138,138,0.10)",
                      border: "none",
                      boxShadow: "inset 0 1px 0 rgba(255,255,255,0.04), 0 4px 12px rgba(138,138,138,0.10)",
                      color: "#AAAAAA",
                    }}
                  >
                    <it.icon size={16} strokeWidth={1.6} />
                  </span>
                  <h3
                    className="font-semibold m-0"
                    style={{
                      fontSize: "14.5px",
                      color: "#f5f5f7",
                      letterSpacing: "-0.02em",
                    }}
                  >
                    {it.title}
                  </h3>
                </div>
                <p
                  className="m-0"
                  style={{
                    fontSize: "12.5px",
                    color: "rgba(245,245,247,0.55)",
                    letterSpacing: "-0.01em",
                    lineHeight: 1.45,
                  }}
                >
                  {it.sub}
                </p>
              </motion.div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
